import React, { useState } from "react";
import { ImageOff } from "lucide-react";

export const ImageWithFallback = ({ src, alt, className = "", imgClassName = "", testid }) => {
  const [error, setError] = useState(false);
  const ok = src && !error;
  return (
    <div className={`relative overflow-hidden bg-paper-muted ${className}`} data-testid={testid}>
      {ok ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onError={() => setError(true)}
          className={`w-full h-full object-cover transition-transform duration-700 ${imgClassName}`}
        />
      ) : (
        <div className="w-full h-full flex flex-col items-center justify-center text-ink-faint bg-[#E6E3DD]" data-testid="photo-placeholder">
          <ImageOff className="w-8 h-8" aria-hidden="true" />
          <span className="mt-2 text-xs">Photo coming soon</span>
        </div>
      )}
    </div>
  );
};

export default ImageWithFallback;
